import React from 'react';

const CareerBenefits = (props) => {

    return (
        <div className="benefit-item">
            <div className="circle" />
            <div className="text-table">
                <div className="text">
                    <h5>{props.title}</h5>
                    <p>{props.value}</p>
                </div>
            </div>
        </div>
    );

};

export default CareerBenefits;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/CareerBenefits.js